export function calculateYearsUntilToday(date: Date) {
  const today = Date.now();
  // Calculate the difference in milliseconds
  const diffInMiliseconds = today - date.getTime();

  // 365.25 accounts for leap years
  const millisecondsPerYear = 1000 * 60 * 60 * 24 * 365.25;

  // Convert the difference from milliseconds to years
  const differenceInYears = diffInMiliseconds / millisecondsPerYear;

  return differenceInYears;
}
